/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
let Iframe = (props) => {
    return (
        <iframe title='video' src={props.src} height={props.height} width={props.width} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; clipboard-write" allowFullScreen />
    )
}
let Video = () => {
    const [videoLink, setVideoLink] = useState([]);
    useEffect(() => {
        // fetch("/apt/source/scenarioVideo")
        fetch(process.env.REACT_APP_VIDEO_API)
            .then(res => res.json())
            .then((result) => {
                setVideoLink(result);

            }).catch(err => {
                throw new Error(err)
            })
    }, [])
    return (
        <div className="section" id="section2">
            <div className="demo_video">
                <Iframe src="https://www.youtube.com/embed/_DndbHj2ogA" height="100%" width="100%" />
            </div>
        </div>
    )

}

export default Video;
